export const getDecimalPlacesValue = (rawDecimalPlaces?: string | number): number => {
  let decimalPlaces = Number(rawDecimalPlaces);

  if (isNaN(decimalPlaces)) {
    decimalPlaces = 2;
  }

  return decimalPlaces;
};
